<template>
  <form class="pronostic">
    <Row>
      <ColumnUi md="3">
        <FormField tag="select" @getValue="handleModel" label="Modelo-dominio">
          <option v-for="(model, index) in models" :key="index">
            {{ index }}
          </option>
        </FormField>
      </ColumnUi>
      <ColumnUi md="6">
        <FormField
          tag="select"
          :disabled="variables.data.length == 0"
          @getValue="handleVariable"
          label="Variables"
        >
          <option v-for="(variable, index) in variables.data" :key="index">
            {{ variable }}
          </option>
        </FormField>
      </ColumnUi>
      <ColumnUi md="3">
        <FormField
          tag="select"
          :disabled="times.data.length == 0"
          @getValue="handleTime"
          label="Tiempo"
        >
          <option
            v-for="(time, index) in times.data"
            :key="index"
            :value="index"
          >
            {{ time }}
          </option>
        </FormField>
      </ColumnUi>
    </Row>
  </form>
  <div v-if="selectedTime.length > 0" class="pronostic__image">
    <img v-bind:src="selectedTime + '?v=' + currentDate" />
  </div>
  <div v-else></div>
  <p>
    La información mostrada en esta página es de carácter experimental y está
    orientada principalmente al grupo de investigadores del IGP y estudiantes
    que desarrollan investigaciones en ciencias de la atmósfera. Puede ser usada
    también por usuarios interesados en el comportamiento de la atmósfera en
    América del sur y el Perú a corto plazo (48 horas).
  </p>
</template>

<script>
import Row from "@/components/ui/atoms/Row";
import ColumnUi from "@/components/ui/atoms/ColumnUi";
import FormField from "@/components/ui/atoms/FormField";
import { model } from "@/model.json";
import { ref, reactive, readonly } from "vue";

export default {
  components: {
    Row,
    ColumnUi,
    FormField
  },
  setup() {
    const models = readonly(model);
    const variables = reactive({ data: [] });
    const times = reactive({ data: [] });
    const currentDate = new Date();
    const selectedModel = ref("");
    const selectedVariable = ref("");
    const selectedTime = ref("");
    const handleModel = value => {
      selectedModel.value = value;
      variables.data = Object.keys(models[value]);
      if (selectedTime.value.length > 0) {
        selectedTime.value = "";
      }
      if (selectedVariable.value.length > 0) {
        times.data = models[selectedModel.value][selectedVariable.value];
      }
    };
    const handleVariable = value => {
      selectedVariable.value = value;
      times.data = models[selectedModel.value][value];
    };
    const handleTime = value => {
      selectedTime.value = value;
    };

    return {
      models,
      handleModel,
      handleVariable,
      handleTime,
      variables,
      times,
      selectedTime,
      currentDate
    };
  }
};
</script>
<style lang="scss" scoped>
@use "@/assets/styles/settings/_variables.scss";
.pronostic {
  margin-bottom: variables.$spacing;
  &__image {
    display: flex;
    justify-content: center;
    margin-bottom: variables.$spacing-s;
  }
}
</style>
